import { faRocket } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Alert, Button } from 'antd'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { getUserProfile } from 'src/redux/store/profile'
import AccessManager from 'src/utils/AccessManager'
import {
  dismissDashboardV3Banner,
  getDashboardV3Destination,
  isDashboardV3BannerDismissed,
  startDashboardV3OptIn,
  trackDashboardV3OptInEvent,
} from 'src/utils/dashboard-v3-opt-in'

const DashboardV3OptInBanner = () => {
  const profile = useSelector(getUserProfile)
  const currentHost = window.location.host
  const destination = getDashboardV3Destination(currentHost)
  const [dismissed, setDismissed] = useState(() => isDashboardV3BannerDismissed(currentHost))

  if (!destination || dismissed) {
    return null
  }

  const eventContext = {
    currentHost,
    organizationId: AccessManager.organizationId || null,
    source: 'v2-banner' as const,
    user: profile.umEmail || null,
    userSub: AccessManager.tokenDetails?.sub || null,
  }

  const handleDismiss = () => {
    dismissDashboardV3Banner(currentHost)
    trackDashboardV3OptInEvent('dashboard_v3_banner_dismissed', eventContext)
    setDismissed(true)
  }

  return (
    <Alert
      banner
      closable
      message={
        <div className='flex flex-wrap items-center justify-between gap-3'>
          <span>Try the new dashboard beta for a faster, cleaner Kenai experience</span>
          <Button type='primary' size='small' onClick={() => startDashboardV3OptIn(eventContext)}>
            Try beta
          </Button>
        </div>
      }
      onClose={handleDismiss}
      showIcon
      type='success'
      closeIcon={
        <Button type='text' size='small'>
          Not now
        </Button>
      }
      icon={<FontAwesomeIcon icon={faRocket} />}
    />
  )
}

export default DashboardV3OptInBanner
